import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var CheckboxGroupItemChangeModel = /*#__PURE__*/_createClass(function CheckboxGroupItemChangeModel(checkboxGroupChangeModel, item) {
  _classCallCheck(this, CheckboxGroupItemChangeModel);

  _defineProperty(this, "item", void 0);

  _defineProperty(this, "checkboxGroupChangeModel", void 0);

  this.checkboxGroupChangeModel = checkboxGroupChangeModel;
  this.item = item;
});